export default {
    props: ["name", "flag", "id", "disabled"],
    data() {
        return {
            status: this.$props.flag
        }
    },
    methods: {
        updateFlag(flag) {
            if (!this.disabled) {
                this.status = flag
                this.$emit('flage', {status: this.status, id: this.$props.id})
            }
        }
    }
}